import "../css/tailwind.css";
import * as Sentry from "@sentry/node";
import { AppProps } from "next/app";
import { RecoilRoot } from "recoil";
import { useAuthState } from "lib/new-auth";
import { initializeFirebase } from "lib/init";
import { ReactChild, useEffect, useState } from "react";
import { IEMessage } from "page-components/static/ie-message";
import { LoadingScreen } from "components/micro-interaction/loader";
import { useGoogleAnalytics } from "lib/hooks/google-analytics";

initializeFirebase();

Sentry.init({
  enabled: process.env["NODE_ENV"] === "production",
  dsn: process.env["NEXT_PUBLIC_SENTRY_DSN"],
});

function AuthContainer({ children }: { children: ReactChild }) {
  const { viewer } = useAuthState();
  return <>{children}</>;
}

function isIE() {
  return /msie\s|trident\//i.test(window.navigator.userAgent);
}

type IEDetectState = "DETECTING" | "IE" | "NOT_IE";
export default function App(props: AppProps) {
  const [ieDetect, setIeDetect] = useState<IEDetectState>("DETECTING");
  useGoogleAnalytics();
  useEffect(() => {
    if (isIE()) {
      setIeDetect("IE");
    } else {
      setIeDetect("NOT_IE");
    }
  }, []);
  if (ieDetect === "DETECTING") {
    <LoadingScreen />;
  }
  if (ieDetect === "IE") {
    return <IEMessage />;
  }
  const Component = props.Component;
  return (
    <RecoilRoot>
      <AuthContainer>
        <Component {...props.pageProps} />
      </AuthContainer>
    </RecoilRoot>
  );
}
